module.exports = __webpack_public_path__ + "img/custom-item3-2.2128d5a.png";